import axios from 'axios'
import store from '@/store'
import {
    message
} from 'ant-design-vue';
// export var baseURL = "http://127.0.0.1:7001"
// export var baseURL = "https://admin.bzdingshe.com"
export var baseURL = process.env.NODE_ENV === 'development' ? "http://127.0.0.1:7002" : "https://admin.bzdingshe.com"
const okcc = axios.create({
    baseURL: baseURL,
    timeout: 60 * 1000, // 设置请求超时时间
    headers: {
        'Content-Type': 'application/json'
    },
});


// 请求拦截器
okcc.interceptors.request.use(
    async (config) => {
        const token = store.state.token
        let clientFingerprint = localStorage.getItem('client_fingerprint')
        if (!clientFingerprint) {
            clientFingerprint = window.crypto && window.crypto.randomUUID
                ? window.crypto.randomUUID()
                : `${Date.now()}-${Math.random().toString(16).slice(2)}`
            localStorage.setItem('client_fingerprint', clientFingerprint)
        }
        config.headers.Authorization = `Bearer ${token}`
        config.headers['X-Client-Fingerprint'] = clientFingerprint
        return config;
    },
    error => {
        // console.error('请求发生错误:', error);
        return Promise.reject(error);
    }
);

// 响应拦截器
okcc.interceptors.response.use(
    response => {
        // 对响应数据进行处理
        const data = response.data;
        if (response.request.responseType == 'blob') {
            return response
        }
        // 这里可以根据后端返回的数据结构进行逻辑判断和处理
        if (data.code == 1) {
            return data
        } else {
            message.error(data.message)
            return Promise.reject(data);
        }
    },
    error => {
        console.log('进error了')
        //重新登录的逻辑
        if (error.response && error.response.status === 401) {
            message.error('登录超时，请登录')
            store.dispatch('Loginout')
        } else {
            let errmessage = error.response ? error.response.data.message : '服务器开小差了';
            message.error(errmessage)
        }
        // 响应错误时的处理
        return Promise.reject(error.response && error.response ? error.response.data : error);
    }
);

export default okcc;
